import { logger } from "@gik/analytics/utils/logger";
import type { SWRConfigInterface } from "@gik/core/api/BaseAPIConfig";
import { wpApi } from "@gik/core/api/ky/wpApi";
import { useApi } from "@gik/core/api/swr/useApi";
import type IConfig from "@gik/core/models/gik/IConfig";
import { useUserStore } from "@gik/core/store/UserStore";

const path = "config";

export function getConfig() {
	return wpApi.get(path).json<IConfig>();
}

export function useConfig(config?: SWRConfigInterface) {
	const [refreshToken, refreshTokenHash] = useUserStore((store) => [
		store.refreshToken,
		store.refreshTokenHash,
	]);

	const result = useApi<IConfig>(
		path,
		{
			// refreshToken: refreshTokenHash ? undefined : refreshToken,
			refreshTokenHash,
		},
		config,
	);

	// automatically replace refresh token after user role change
	if (result.data?.refreshToken && result.data?.refreshToken !== refreshToken) {
		useUserStore
			.getState()
			.login(result.data.refreshToken, result.data.refreshTokenHash);
		logger.info("Automatically updated refresh token with new permissions", {
			data: result.data,
		});
	}

	return result;
}
